import { TranslatableEntity } from '~/app/core/models/translatable-entity';
import { PostLanguage } from '../../feed/models/post-language';
import { Context } from '../../mgmt/context/models/context';

export class MediaDirectory extends TranslatableEntity<MediaDirectory, PostLanguage> {
  public navtitleTranslated?: string;
  public nameTranslated?: string;

  name = '';
  parent?: MediaDirectory;
  hasChildren?: boolean;
  key?: string;
  contexts: Context[] = [];
  public updateTranslations(): void {
    const translation = this.getPropertyTranslation(this.translatedEntities, 'name');
    this.nameTranslated = this.navtitleTranslated = translation?.name.toString() ?? '';
  }
}
